import axios from 'axios';

// Get token based on currentRole
const getToken = () => {
  const role = localStorage.getItem('currentRole');
  if (role === 'admin') {
    return localStorage.getItem('adminAuthToken');
  } else if (role === 'user') {
    return localStorage.getItem('authToken');
  }
  return null;
};

const api = axios.create({
  baseURL: 'https://khanafeederp.a1professionals.net/api/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Automatically attach Authorization token
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
